import { render, staticRenderFns } from "./metadataDetail.vue?vue&type=template&id=aff14a7c&scoped=true&"
import script from "./metadataDetail.vue?vue&type=script&lang=js&"
export * from "./metadataDetail.vue?vue&type=script&lang=js&"
import style0 from "./metadataDetail.vue?vue&type=style&index=0&id=aff14a7c&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff14a7c",
  null
  
)

export default component.exports